import { IconCheck } from './icons/IconCheck';
import { IconClose } from './icons/IconClose';
import { IconCloseCircle } from './icons/IconCloseCircle';
import { IconInfoCircle } from './icons/IconInfoCircle';
import { IconUpload } from './icons/IconUpload';
import { IconWarning } from './icons/IconWarning';
import { IconReload } from './icons/IconReload';

const icons = {
  check: IconCheck,
  close: IconClose,
  closeCircle: IconCloseCircle,
  infoCircle: IconInfoCircle,
  reload: IconReload,
  upload: IconUpload,
  warning: IconWarning
};

export type IconNames = keyof typeof icons;

type IconProps = {
  name: IconNames;
};

export const Icon = ({ name }: IconProps) => icons[name]();
